export default __webpack_public_path__ + "static/media/misc-closetC-2048w.036abc5d.webp";